import { render, staticRenderFns } from "./ImgStyle.vue?vue&type=template&id=4ab4aec1&scoped=true"
import script from "./ImgStyle.vue?vue&type=script&lang=js"
export * from "./ImgStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4aec1",
  null
  
)

export default component.exports